import type { CallRequest, RequestsStatus } from './clientMeetings'

export interface ClientEmail {
  _id: string
  subject: string | null
  date: string
  loggedByName: string | null
  requestsStatus: RequestsStatus
  requests: CallRequest[]
}

export const MAX_EMAIL_LENGTH = 100000
